// src/StyledComponents.js
import styled, { keyframes }  from 'styled-components';

import imgBg from "../images/grunge-paper-background.jpg";
import imgBorder from "../images/border.png";

const mobileBreakpoint = '768px';

export const UnicodeIcon = styled.span`
  font-family:inherit;
`;

export const IconLogo = ()=>{
  return (
      <UnicodeIcon>🌼</UnicodeIcon>
  )
};

export const IconSquare = ()=>{
  return (
      <UnicodeIcon>▪</UnicodeIcon>
  )
};


export const Navbar = styled.nav`
  background-color: var(--yellow-300);
  z-index:999;
  position: relative;
  padding: 1em;
  display: flex;
  align-items: center;



  h1 {
    color:black;
    font-size:1.5em;
  }

  h1 a {
    color:black;
    font-family:"Header";
  }

`;

export const HiddenMobile = styled.span`

 @media (max-width: ${mobileBreakpoint}) {
    display: none; // hide the component on mobile screens
  }
`;

export const ShowMobile = styled.span`

 @media (min-width: ${mobileBreakpoint}) {
    display: none; // hide the component on mobile screens
  }
`;

export const NavbarLinks = styled.span`
  display: flex; // To layout the links horizontally
  margin-left: auto; // Push the span to the far right
  color: #777;


  a {
    font-size: 0.75em;
    font-weight:bold;
    font-family: "Header";
    color: black;
    text-decoration: none;
    margin-left: 0.75em;
    margin-right: 0.75em;
    text-transform:uppercase;
  }

  a:hover {
    text-decoration: underline;
  }

`;


export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center; // Center the columns if they are less than the container's width
`;

export const Break = styled.div`
  height: 1em;
`;

export const Section = styled.div`
  /*background-color: ${props => props.bg || '#ccc'};*/
  position: relative;
  font-size: 1.3em;


  h1 {
    font-size:3.5em;
    margin: 0;
    padding: 0;
    margin-bottom: -0.2em;
  }
`;

export const HeroContainer = styled.div`
    /*padding: 5em 0;
    min-height: fit-content;
    max-height: 3500px;
    display: flex;
    flex-direction: row; 
    justify-content: center; 
    align-items: center;

    flex-wrap: wrap; */

    height: ${props => props.height || '100vh'};
    min-height: fit-content;
    max-height: 3500px;
    display: flex; /* Enables Flexbox */
    flex-direction: row; /* Aligns children in a row */
    justify-content: center; /* Centers content horizontally */
    align-items: center; /* Centers content vertically */

    flex-wrap: wrap; /* Allows items to wrap onto multiple lines */
`

export const FixedHeightContainer = styled.div`
    height: ${props => props.height || '90vh'};
    min-height: fit-content;
    max-height: 3500px;
    display: flex; /* Enables Flexbox */
    flex-direction: row; /* Aligns children in a row */
    justify-content: center; /* Centers content horizontally */
    align-items: center; /* Centers content vertically */

    flex-wrap: wrap; /* Allows items to wrap onto multiple lines */
`;

export const Column = styled.div`
  width:40vw;
  margin: 0 1em;
`;


export const ColumnHeroImage = styled.div`
  width:80vw;
  max-width:400px;
  margin: 0 1.5em;

  @media (max-width: ${mobileBreakpoint}) {
     width:80vw;
     //display: none;
  }
`;

export const Copyright = styled.div`
  text-align: center;
  margin: 0.5em 0em 2em 0;

  p {
    font-size: 0.5em;
  }
`;

export const ColumnHeroDesc = styled.div`
  width:40vw;
  max-width:450px;
  margin: 3em 0em 0em 0em;

  border: 81px solid transparent; /* match slice height */
  border-image-source: url(${imgBorder});
  border-image-slice: 81 68 81 68 fill; /* top right bottom left */
  border-image-repeat: repeat;     /* or stretch/round */
  
  padding: 0em 0em;
  text-align:center;
  
  position: relative;


  @media (max-width: ${mobileBreakpoint}) {
     width:100vw;
     max-width:100vw;
     padding: 2em;
     margin: 0.5em;

    border: 2px solid #58410a;
    border-radius: 15px;
    box-shadow: inset 0px 0px 8px rgba(0, 0, 0, 0.5), 0px 0px 8px rgba(0, 0, 0, 0.8);

  }
`;


export const ColumnThirds = styled.div`
  width:25vw;
  margin: 0 1em;
  color: black;

  h2 {
    color: black;
    border-bottom: 1px solid black;
    padding: 0.5em 0;
    font-size:1em;
  }

   @media (max-width: ${mobileBreakpoint}) {
     width:100vw;
  }

`;

export const FAQSection = styled.div`
  width: 90%;
  max-width: 2000px;
  margin: 0 auto;
  padding: 3em 0 1em 0;

  @media (max-width: ${mobileBreakpoint}) {
     width:90vw;
  }

  h1 {
    color: black;
    font-size:1.5em;
    padding-bottom: 0em;
    border-bottom: 1px solid black;
  }

`;

export const Button = styled.button`
  background-color:#a7dd3a;
  color: black;
  border: none;
  padding: 0.3em 1em;
  border-radius: 7px;
  margin-right:4px;

  font-family:"Header";

  border: 2px solid #58410a;

  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  font-size: 1.1em;
  
  box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.6), inset 0px 0px 4px rgba(0, 0, 0, 0.7);

    &:hover {
      // Add your hover styles here
      background-color: var(--yellow-100); // Replace with the desired background color
      color: var(--black); // Replace with the desired text color
       cursor: pointer; 
      
    }

    &:active {
      background-color: var(--yellow-300); // Set the background color to red when the button is clicked
    }

    &:disabled {
      color: #333; // Replace with the desired text color
      background-color: var(--camo-300);
       cursor: not-allowed;
    }

`;



export const FAQQuestion = styled.div`
  color: black;
  margin: 3em 0;

  h2 {
    margin-bottom: 0.5em;
  }

  p {
    margin-bottom: 1em;
  }

  h2 {
    color: black;
    padding: 0.5em 0;
    font-size:1em;
  }

  a {
    color: var(--mars-300);
  }

`;


export const ResponsiveImage = styled.img`
  width: 100%; // Make image take full width of the container
  height: auto; // Keep image aspect ratio
  //max-width: 500px; // Maximum width of the image
/*
  // Add a media query for larger screens
  @media (min-width: 768px) {
    max-width: 100%; // On larger screens, let the image take full width
  }*/
`;


export const ErrorMessage = styled.div`
  background-color:red;
  font-size: 0.6em;
  padding: 0.75em;
  margin-top: 0.5em;
  border: 1px solid yellow;
  word-break: break-word;
  color: yellow;
  font-family:monospace;
`;

export const SuccessMessage = styled.div`
  background-color:var(--lime-300);
  color:black;
  font-size: 0.6em;
  padding: 0.75em;
  margin-top: 1em;
  border-radius: 5px;
  border: 1px solid black;
  word-break: break-word;

  a {
    color: blue;
  }
`;
